import { useContext } from 'react'
import GoogleGeoJSON from '../googleMap/geoJson'
import MapboxGeoJSON from '../mapbox/geoJson'
import { MapContext } from './mapContext'
import {
  FeatureCollectionWithInfoAndStyle,
  FeatureWithInfoAndStyle,
} from '~/packages/sentinel/statsAndGeoToFeatureCollection.util'

interface GeoJSONProps {
  geoJson: FeatureCollectionWithInfoAndStyle
  idPropertyName?: string
  renderInfoWindow?: (props: { feature: FeatureWithInfoAndStyle }) => JSX.Element
  onClick?: (
    event: google.maps.Data.MouseEvent | (mapboxgl.MapMouseEvent & mapboxgl.EventData),
    feature: FeatureWithInfoAndStyle | undefined,
  ) => void
}

export default function GeoJSON<T>(props: GeoJSONProps) {
  const mapContext = useContext(MapContext)
  if (!mapContext) {
    throw new Error('GeoJSON must be used within a map')
  }

  const { mapProvider } = mapContext

  let layerJSXElement: JSX.Element

  switch (mapProvider) {
    case 'google':
      layerJSXElement = (
        <GoogleGeoJSON {...props} onClick={event => props.onClick?.(event, undefined)} />
      )
      break
    case 'mapbox':
      layerJSXElement = <MapboxGeoJSON {...props} />
      break
    default:
      throw new Error(`Unsupported map provider: ${mapProvider}`)
  }

  return layerJSXElement
}
